export default __webpack_public_path__ + "static/media/avatar-s-18.9af4f6d3.jpg";